import transformToCamelCase from '@/api/shared/transformers/toCamelCaseTransformer';
import { format as formatDate } from '@/utils/date';
import translator from '@/locales';

export default function transformReportDailyStats(data) {
  data.stats = Object.values(data.stats).map(stat => ({
    name: stat.title,
    overall: stat.overall,
    series: createSeriesFromData(stat, data.campaigns),
    overallSeries: createAggregateSeries(stat, data.dates),
  }));

  data.dates = data.dates?.map(ts => formatDate(ts, 'jYYYY/jMM/jDD', 'X'));

  return data;
}

function createSeriesFromData(stat, campaigns) {
  const campaignsDailyData = stat.daily_data.campaigns;

  return campaigns.map(campaign => ({
    name: campaign.title,
    data: Object.values(campaignsDailyData[campaign.uuid]),
  }));
}

function createAggregateSeries(stat, dates) {
  const overallDailyData = stat.daily_data.overall;
  const data = dates.map(date => overallDailyData[date]);
  return [
    {
      name: stat.title,
      data,
    },
  ];
}
